<template>
  <th v-if="isHeader">
    {{'Actions' | trans}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button v-if="!isSelected" class="btn btn-primary mb-1" @click="addToReport(rowData, rowIndex)">
        <i class="icons icon-plus"></i>&nbsp;{{'Add to report' | translate }}
      </button>
      <button v-else class="btn btn-danger mb-1" @click="removeFromReport(rowData, rowIndex)">
        <i class="icons icon-minus"></i>&nbsp;{{'Remove from report' | translate }}
      </button>
    </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isSelected() {
      return this.$store.getters.currentCompanySelectedReportRows.indexOf(this.rowData.joint_id) !== -1
    }
  },
  methods: {
    addToReport(data, index) {
      this.$store.commit('setCurrentReport', data)
    },
    removeFromReport(data, index) {
      this.$store.commit('removeCurrentReportEntry', data.joint_id)
      this.$store.commit('removeSelectedReportRowsEntry', data.joint_id)
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableJointActions.vue?8d97f88e